module.exports = __webpack_public_path__ + "static/media/favicon.a5f41c88.jpeg";